// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import ActionForm from './components/widget/ActionForm'
import App from './App'
import {router, addAsyncRoutes} from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import {debounce} from 'throttle-debounce'
import CustomLoading from './directive/customLoading'
import pathUtils from './util/pathUtils'
import uploader from 'vue-simple-uploader'
import '../static/whaty-face-detector'

Vue.config.productionTip = false
/* 兼容旧版 Popconfirm 事件名（新版 confirm -> 旧版 onConfirm），需在 Vue.use 之前修改 */
const Popconfirm = ElementUI.Popconfirm
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.confirm) {
  const originalConfirm = Popconfirm.methods.confirm
  Popconfirm.methods.confirm = function () {
    this.$emit('onConfirm')
    originalConfirm.call(this)
  }
}
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.cancel) {
  const originalCancel = Popconfirm.methods.cancel
  Popconfirm.methods.cancel = function () {
    this.$emit('onCancel')
    originalCancel.call(this)
  }
}
/* 引入cookie工具 */
Vue.use(VueCookies)
/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
/* 注册自定义的loading指令 */
Vue.use(CustomLoading)
/* 引入切片上传 */
Vue.use(uploader)
/* 注册全局组件 */
Vue.component('action-form', ActionForm)

/**
 * 登录授权
 */
const accessToken = VueCookies.get('student-access-token')
if (accessToken) {
  store.commit('setAccessToken', accessToken)
}

/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  return new Promise((resolve, reject) => {
    let requestUrl = config.url
    if (requestUrl && requestUrl.startsWith('/')) {
      config.url = pathUtils.getContextPath(requestUrl)
    }
    store.dispatch('globalRequestHeaders', config.url).then(val => {
      if (val) {
        Object.keys(val).forEach(key => {
          config.headers.common[key] = val[key]
        })
      }
      resolve(config)
    }).catch(err => {
      reject(err)
    })
  })
})

/* 会话失效弹窗提示 */
const timeoutMessageBox = debounce(500, (path) => {
  ElementUI.MessageBox.alert('您的登录已经超时，请点击按钮重新登录', '提示', {
    center: true,
    showClose: false,
    showCancelButton: false,
    closeOnClickModal: false,
    callback: () => {
      window.location.href = pathUtils.getContextPath(path)
    }
  })
})

$axios.interceptors.response.use(response => {
  if (response.data) {
    if (response.data['needRedirect']) {
      timeoutMessageBox(response.data['redirectUrl'])
    }
  }
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    ElementUI.MessageBox.alert('授权信息不存在，请重新登录', '提示', {
      center: true,
      showClose: false,
      showCancelButton: false,
      closeOnClickModal: false,
      callback: () => {
        window.location.href = pathUtils.getContextPath('/')
      }
    })
  }
  return Promise.reject(error)
})

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = function (config) {
  config.instance = this
  return $axios(config)
}
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$extend = function () {
  return Object.assign({}, ...arguments)
}
Vue.prototype.$contextPath = pathUtils.getContextPath

// 动态添加路由
addAsyncRoutes()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
